module.exports = __webpack_public_path__ + "images/psp/Truck/illustration-truck-and-mover.webp";